var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocushield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DOCUSHIELD",
    transform: "translate(-736.014 -548.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65002",
    "data-name": "Path 65002",
    d: "M765.859,569.118a3.8,3.8,0,1,0-7.591.117v2.475h7.592v-2.475C765.86,569.2,765.86,569.157,765.859,569.118Z",
    transform: "translate(-1.05 -0.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65003",
    "data-name": "Path 65003",
    d: "M762.131,578.5a2.48,2.48,0,1,0,2.449,2.48h0A2.465,2.465,0,0,0,762.131,578.5Z",
    transform: "translate(-1.117 -1.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65004",
    "data-name": "Path 65004",
    d: "M785.96,556.583s-24.946-6.927-24.946-7.937h0c0,1.011-24.946,7.938-24.946,7.938a104.4,104.4,0,0,0,2,23.958c6.272,21.794,22.951,24.1,22.951,24.1h0s16.677-2.309,22.949-24.1A104.432,104.432,0,0,0,785.96,556.583ZM770.81,586a2.472,2.472,0,0,1-2.45,2.479H753.668a2.472,2.472,0,0,1-2.45-2.48V573.6a2.472,2.472,0,0,1,2.45-2.479h1.224v-2.479a6.122,6.122,0,1,1,12.244,0v2.478h1.224a2.472,2.472,0,0,1,2.45,2.48Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocushield);
export default __webpack_public_path__ + "static/media/docushield.72e4caa48cf40ec4419ddc0f48557c1c.svg";
export { ForwardRef as ReactComponent };